'use strict';

/**
 * Canonical Cash Report view from ONE forecast_versions payload.
 * Keep in lockstep with server/features/aria/reconcileForecastView.js
 */
const VIEW_VERSION = 1;

function weekCloseDollars(w) {
  if (!w) return null;
  if (w.close && Number.isFinite(Number(w.close.amount))) return Number(w.close.amount);
  if (w.close_cents != null && Number.isFinite(Number(w.close_cents))) {
    return Number(w.close_cents) / 100;
  }
  return null;
}

function weekInDollars(w) {
  if (!w || !w.in) return 0;
  return Number.isFinite(Number(w.in.amount)) ? Number(w.in.amount) : 0;
}

function addDaysIso(iso, days) {
  const [y, m, d] = String(iso || '').slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return '';
  const dt = new Date(y, m - 1, d + days);
  const yy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const dd = String(dt.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

function inNext30Days(iso, today) {
  const w = String(iso || '').slice(0, 10);
  const t = String(today || '').slice(0, 10);
  if (!w || !t) return false;
  const end = addDaysIso(t, 30);
  return w >= t && w <= end;
}

function calendarDay(value) {
  if (value instanceof Date && Number.isFinite(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  const m = String(value || '').match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : '';
}

function reconcileForecastView(version, overlay) {
  const payload = (version && version.payload) || {};
  const weeks = Array.isArray(payload.weeks) ? payload.weeks : [];
  const today = calendarDay(version && version.bank_as_of)
    || (weeks[0] && weeks[0].week_start) || '';

  const cashNow = overlay && overlay.cents != null
    ? Number(overlay.cents) / 100
    : version && version.opening_cash_cents != null
      ? Number(version.opening_cash_cents) / 100
      : null;

  const windowWeeks = weeks.filter((w) => inNext30Days(w.week_start, today));
  const expectedIn = windowWeeks.reduce((s, w) => s + weekInDollars(w), 0);
  const listOut = payload.payments_list && payload.payments_list.total;
  const dueOut = listOut && Number.isFinite(Number(listOut.amount))
    ? Number(listOut.amount)
    : null;
  const in30 = cashNow == null
    ? null
    : cashNow + expectedIn - (dueOut || 0);

  const series = weeks.map(weekCloseDollars).filter((n) => n != null);
  const lowest = series.length ? Math.min(...series) : null;
  const tileSeries = [];
  if (cashNow != null) tileSeries.push(cashNow);
  for (const n of series) tileSeries.push(n);

  return {
    v: VIEW_VERSION,
    cashNow,
    expectedIn,
    dueOut,
    in30,
    series,
    tileSeries,
    lowest,
    thisWeek: series.length ? series[0] : null,
    nextWeek: series.length > 1 ? series[1] : null,
  };
}

export {
  VIEW_VERSION,
  reconcileForecastView,
  weekCloseDollars,
  inNext30Days,
  addDaysIso,
};
